import React from 'react';
import { PlayIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-transparent pt-16 pb-24 lg:pt-24 lg:pb-32" data-id="element-83">
      {/* Decorative background blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-84">
        <div className="absolute -top-[10%] -right-[10%] w-[50%] h-[50%] rounded-full bg-pink-soft/20 blur-3xl" data-id="element-85" />
        <div className="absolute top-[20%] -left-[10%] w-[40%] h-[40%] rounded-full bg-mint/20 blur-3xl" data-id="element-86" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-88">
          {/* Left Column: Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-start text-left" data-id="element-89">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-dark leading-tight mb-6" data-id="element-90">
              Domina el Arte del Tricotín y Crea un{' '}
              <span className="text-rose" data-id="element-91">Negocio Rentable</span> desde Casa
            </h1>
            <p className="text-lg sm:text-xl text-muted mb-8 max-w-xl leading-relaxed" data-id="element-92">
              Aprende paso a paso cómo crear hermosas piezas decorativas con
              tricotín y empieza a generar ingresos desde casa en solo 30
              minutos al día.
            </p>
            <button onClick={() => document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-rose text-white font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-pulse-cta" aria-label="Quiero Empezar Ahora" data-id="element-93">
              ¡Quiero Empezar Ahora!
            </button>
          </motion.div>

          {/* Right Column: Video Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0,
          y: [0, -10, 0]
        }} transition={{
          opacity: {
            duration: 0.6,
            delay: 0.2
          },
          x: {
            duration: 0.6,
            delay: 0.2
          },
          y: {
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="relative w-full aspect-[4/5] md:aspect-[3/4] lg:aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl group border-4 border-white" data-id="element-94">
            <video src="https://cdn.magicpatterns.com/uploads/da5eT7g224XZpgPpUmN1Ry/Master Kit Tricotín Rentable.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-95" />

            {/* Subtle gradient overlay to make it look premium */}
            <div className="absolute inset-0 bg-gradient-to-t from-dark/60 via-transparent to-transparent opacity-80" data-id="element-96" />

            <div className="absolute bottom-6 left-6 right-6 flex justify-between items-center text-white font-medium" data-id="element-97">
              <span className="bg-dark/60 backdrop-blur-md px-4 py-1.5 rounded-full text-sm border border-white/20" data-id="element-98">
                Aprende paso a paso
              </span>
              <span className="flex items-center gap-2 text-sm bg-berry/90 backdrop-blur-md px-3 py-1.5 rounded-full shadow-lg" data-id="element-99">
                Guía Práctica
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}